import AuthenticatedResource from 'resources/public/AuthenticatedResource'

export default class SubscriptionResource extends AuthenticatedResource {
  static urlRoot = '/organizations/:organization_id/subscriptions/' as const;

  readonly id: number | undefined = undefined;

  pk() {
    return this.id?.toString();
  }
}
